import React from 'react';
import { MockService } from '../../../../types/rest/mockServiceTypes';
import { Button } from 'react-bootstrap';
import DeploymentInfoModal from './Modals/DeploymentInfoModal';

interface DeploymentInfoProps {
  mockService: MockService;
}

const DeploymentInfo = (props: DeploymentInfoProps) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <div className="mt-3">
      {showModal && <DeploymentInfoModal mockService={props.mockService} onHide={() => setShowModal(false)} />}
      <Button variant="link" className={'btn-link btn-no-hover btn-sm p-0 m-0'} onClick={() => setShowModal(true)}>
        Show Deployment Timing
      </Button>
    </div>
  );
};

export default DeploymentInfo;
